// In Electron, the editor ships as an IIFE bundle (built by
// scripts/build-editor.js) that exposes `window.LastslateEditor`.
// In the web build we import the editor's ESM source directly via
// Vite and re-attach it to window so the classic-script renderer
// can keep calling `window.LastslateEditor.mountEditor(...)` etc.

import * as LastslateEditor from '../renderer/js/editor/index.js';

if (!globalThis.LastslateEditor) {
  globalThis.LastslateEditor = LastslateEditor;
}
